import BottomNavigation from './bottomNavigation.js';
export default BottomNavigation;
